<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <NoEditorWrapper
    class="d-flex align-center justify-center"
    badge-text="Upgrade"
    :has-tooltip="true"
    :badge-style="{ top: '-10px', left: '50%' }"
  >
    <SubmenuDropdown
      :close-on-click="true"
      class="dropdown-icon"
      round
      @mouseenter="$emit('tracking-event', {
        action: 'navDropdownHover',
        args: { label: 'Write' },
      })"
    >
      <div class="icon-text-pair">
        <DpplSvg file-name="icon-plus" />
        <span class="ml-1">
          Write
        </span>
      </div>
      <NavigationMenu
        :columns="1"
        :link-sections="[{ links: nestedDropdownNavLinks }]"
        :min-width="0"
        @tracking-event="(params) => $emit('tracking-event', params)"
      />
    </SubmenuDropdown>
    <CreateDraftModal
      :show="modals.createDraft"
      :template-list="templateList"
      @close="$emit('set-modal', { field: 'createDraft', value: false })"
    />
  </NoEditorWrapper>
</template>

<script>
import CreateDraftModal from '@/components/shared/CreateDraftModal.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import NavigationMenu from '@/components/shared/NavigationMenu.vue';
import NoEditorWrapper from '@/components/editor/NoEditorWrapper.vue';
import SubmenuDropdown from '@/components/editor/SubmenuDropdown.vue';
import { useAppAuthData } from '@/stores/app/authData';
import { mapState } from 'pinia';

export default {
  name: 'CreateDraftDropdown',
  components: {
    CreateDraftModal,
    DpplSvg,
    NavigationMenu,
    NoEditorWrapper,
    SubmenuDropdown,
  },
  props: {
    atsCreateUrl: { type: String, default: '' },
    modals: { type: Object, default: () => ({}) },
    templateList: { type: Array, default: () => [] },
  },
  emits: ['set-modal', 'tracking-event'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
    nestedDropdownNavLinks() {
      const links = [];

      if (this.atsCreateUrl) {
        links.push({
          show: true,
          title: 'Open a Req',
          href: this.atsCreateUrl,
          attributes: {
            target: '_blank',
          },
        });
      }

      links.push({
        show: true,
        title: 'Write a Post',
        onClick: () => {
          this.openModal('Draft');
        },
      });

      if (this.authData.jobProfileEnabled) {
        links.push({
          show: true,
          title: 'Write a Job Profile',
          onClick: () => {
            this.$router.push({ name: 'create-job-profile' });
          },
        });
      }

      return links;
    },
  },
  methods: {
    openModal(type) {
      this.$emit('set-modal', {
        field: `create${type}`,
        value: !this.modals[`create${type}`],
      });
    },
  },
};
</script>

<style scoped lang="less">
.icon-text-pair {
  display: flex;
  align-items: center;
  span {
    font-size: 15px;
    font-weight: 500;
  }
}

:global(.create-draft-nested-navigation-dropdown) {
  padding: 0 10px;
  border-radius: 8px;
  color: @text-darkest;
}

:global(.create-draft-nested-navigation-dropdown.open) {
  background-color: fade(@bg-brand-default, 5%);
  color: @text-brand;
}
</style>
